/* eslint-disable */
import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`
export const GOOGLE_LOGIN = gql`
  mutation GoogleLogin($googleTokenId: String, $authorizationCode: String, $usePostmessage: Boolean) {
    googleLogin(
      googleTokenId: $googleTokenId
      authorizationCode: $authorizationCode
      usePostmessage: $usePostmessage
    )
  }
`
export const FACEBOOK_LOGIN = gql`
  mutation FacebookLogin($authorizationCode: String!) {
    facebookLogin(authorizationCode: $authorizationCode)
  }
`
export const LOGIN_NEW_USER_FOR_CHECKOUT = gql`
  mutation loginNewUserForCheckout($email: String!, $password: String!) {
    loginNewUserForCheckout(email: $email, password: $password)
  }
`

export const IS_TOKEN_VALID = gql`
  mutation IsTokenValid {
    isTokenValid
  }
`
export const LOGOUT = gql`
  mutation LOGOUT {
    logout
  }
`

export const SEND_OTP = gql`
  mutation SendOtp($email: String!, $lang: String!) {
    sendOtp(email: $email, lang: $lang)
  }
`

export const LOGIN_WITH_OTP = gql`
  mutation LoginWithOtp($email: String!, $otp: String!, $isLegacyBrowser: Boolean) {
    loginWithOtp(email: $email, otp: $otp, isLegacyBrowser: $isLegacyBrowser)
  }
`

export const CREATE_PENDING_ACCREDITATION = gql`
  mutation CreatePendingAccreditation(
    $eventId: ID!
    $attendee: AttendeeInput!
    $token: String!
    $workshopIds: [ID!]
    $referralName: String
  ) {
    createPendingAccreditation(
      attendee: $attendee
      token: $token
      eventId: $eventId
      workshopIds: $workshopIds
      referralName: $referralName
    )
  }
`

export const CREATE_PENDING_ACCREDITATION_PUBLIC = gql`
  mutation CreatePendingAccreditationPublic(
    $eventId: ID!
    $attendee: AttendeeInputPublic!
    $workshopIds: [ID!]
    $referralName: String
    $ticketingEnabled: Boolean!
  ) {
    createPendingAccreditationPublic(
      eventId: $eventId
      attendee: $attendee
      workshopIds: $workshopIds
      referralName: $referralName
      ticketingEnabled: $ticketingEnabled
    ) {
      id
      fields
      status
      zones
      barcode
      category {
        id
        color
        name
        zones
      }
      avatar
    }
  }
`
export const CREATE_FLOOR_PLAN_PENDING_ACCREDITATION_PUBLIC = gql`
  mutation CreateFloorPlanPurchaseAccreditationsPublic(
    $eventId: ID!
    $attendeePurchasePublicData: AttendeePurchasePublicInput!
  ) {
    createFloorPlanPurchaseAccreditationsPublic(
      eventId: $eventId
      attendeePurchasePublicData: $attendeePurchasePublicData
    ) {
      createdAccreditations {
        accreditation {
          id
          ticketLocation
        }
        ticketId
      }
      createdPurchases {
        id
        orderId
        attendeeId
        orderItemId
      }
      createdOrder {
        id
        uuid
        eventId
        status
      }
      quantityPerOrderItem
    }
  }
`

export const CREATE_PURCHASE_ACCREDITATIONS_PUBLIC = gql`
  mutation CreatePurchaseAccreditationsPublic(
    $eventId: ID!
    $attendees: [AttendeeInputPublic!]!
    $workshopIds: [ID!]
    $referralName: String
    $promoCodeId: ID
    $membershipUserCode: Int
    $subscriptions: [SubscriptionData!]
    $buyer: AttendeeInputPublic!
    $price: String
  ) {
    createPurchaseAccreditationsPublic(
      eventId: $eventId
      attendees: $attendees
      workshopIds: $workshopIds
      referralName: $referralName
      promoCodeId: $promoCodeId
      subscriptions: $subscriptions
      membershipUserCode: $membershipUserCode
      buyer: $buyer
      price: $price
    ) {
      createdAccreditations {
        accreditation {
          id
        }
        ticketId
      }
      createdPurchases {
        id
        orderId
        attendeeId
        orderItemId
      }
      createdOrder {
        id
        uuid
        eventId
        status
      }
      quantityPerOrderItem
    }
  }
`

export const CREATE_PURCHASE_ACCREDITATIONS_PUBLIC_CONFERENCE_TICKETING = gql`
  mutation CreatePurchaseAccreditationsPublicConferenceTicketing(
    $eventId: ID!
    $attendeeTicketId: [ID!]!
    $buyer: AttendeeInputPublic!
    $attendeeUUID: String!
    $requestUUID: String
  ) {
    createPurchaseAccreditationsPublicConferenceTicketing(
      eventId: $eventId
      attendeeTicketId: $attendeeTicketId
      buyer: $buyer
      attendeeUUID: $attendeeUUID
      requestUUID: $requestUUID
    ) {
      createdAccreditations {
        accreditation {
          id
          fields
        }
        ticketId
      }
      createdPurchases {
        id
        orderId
        attendeeId
        orderItemId
      }
      createdOrder {
        id
        uuid
        eventId
        status
        canResumeReservationCheckout
        createdAt
      }
      orderItem {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        initialQuantity
        from
        to
      }
    }
  }
`

export const DOWNLOAD_TEMPLATE = gql`
  query DownloadTemplate($eventId: ID!) {
    downloadTemplate(eventId: $eventId) {
      content
      fileName
    }
  }
`

export const GET_AUTHORIZATION = gql`
  query GetAuthorization($eventId: ID, $organizationSlug: String, $eventTemplateId: ID) {
    getAuthorization(
      eventId: $eventId
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      isAuthorized
      type
      organizationRole
      event {
        id
        extraModules {
          categoriesAndZones
          mobileApp
          conferenceMobileApp
          expoMobileApp
          workshops
          scanEntries
        }
      }
    }
  }
`
export const GET_USER = gql`
  query GetUser {
    me {
      id
      eventQuota
      type
      disabled
      firstName
      lastName
      email
      flags
      isVerifiedByCoreEvent
    }
  }
`
